import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-336308a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "img-content"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  key: 0,
  class: "item-pic"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "digest"
};
const _hoisted_7 = {
  class: "info"
};
const _hoisted_8 = {
  class: "date"
};
const _hoisted_9 = {
  class: "preview-count"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-view"
}, null, -1));
const _hoisted_11 = {
  class: "like-count"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-like"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, item => {
    return _openBlock(), _createElementBlock("a", {
      key: item.title,
      class: "img-content-item",
      href: _ctx.handleUrl(`news/detail/${item.id}`),
      target: "_blank"
    }, [item.general_image ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
      src: item.general_image,
      alt: item.title
    }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(['item-content', {
        'no-img-content': !item.general_image
      }])
    }, [_createElementVNode("h3", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(item.digest), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatTimestamp(`${item.issue_at}`)), 1), _createElementVNode("span", _hoisted_9, [_hoisted_10, _createTextVNode(_toDisplayString(item.view), 1)]), _createElementVNode("span", _hoisted_11, [_hoisted_12, _createTextVNode(_toDisplayString(item.like), 1)])])], 2)], 8, _hoisted_2);
  }), 128))]);
}